export const loadUserPreferences = async () => {
  const segment = await import('@segment/consent-manager');
  return segment.loadPreferences();
};
